<template>
  <el-dialog
    title="保险方案"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="400px"
    class="dialog_title dialog-style-1"
    @close="onClose"
    @closed="onClosed"
  >
    <el-form :model="formData" :rules="formRules" ref="form" label-width="100px">
      <el-form-item label="购买人数：">购买人数：{{ formData.buy_num }}人</el-form-item>

      <el-form-item label="方案：" prop="type">
        <el-select
          v-model="formData.type"
          placeholder="请选择方案"
          clearable
          :style="{ width: '100%' }"
          size="small"
          @change="insureSchemeChange"
        >
          <el-option
            v-for="(item, index) in insureScheme"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="费用：">
        {{ formData.cost }}元/人，共{{ formData.total }}元
      </el-form-item>
      <el-form-item label="转账凭证：">
        <dc-upload
          v-if="dcUploadConfig.key"
          class="avatar-uploader"
          ref="upload"
          :dcAutoUpload="true"
          dcdom="uploadProof"
          :dcConfig="dcUploadConfig"
          :file-list="fileList"
          :limit="10"
          @dc-success="uploadSuccess"
          :on-remove="uploadFileRemove"
        >
          <el-button type="primary" size="mini">选择文件</el-button>
        </dc-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit('form')">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getApiInsureScheme } from "@/api/tearcher";
import { UPloadFileApi, GetKey_Url } from "@/api/student";
export default {
  props: {
    //保险购买接口
    postApiBuy: {
      type: Function,
      default: () => {},
    },
    //角色类型
    roleType: {
      type: Number,
      default: "0",
    },
  },
  data() {
    return {
      dialogVisible: false, //弹窗是否显示
      //表单数据
      formData: {
        class_id: sessionStorage.getItem("class_id"),
        type: "",
        buy_num: "",
        cost: 0,
        total: 0,
        file_id: "",
        class_user_id: "",
      },
      //表单验证
      formRules: {
        type: [{ required: true, message: "请选择保险方案", trigger: "change" }],
      },
      dcUploadConfig: {}, //德诚上传配置
      fileList: [], //上传文件列表
      insureScheme: [], //保险方案
      tableSelection: [], //表格选择数组
    };
  },
  methods: {
    //更新数据
    update() {
      this.$emit("update");
      this.dialogVisible = false;
    },
    //打开
    open(e) {
      this.formData.buy_num = e.tableSelection.length;
      this.tableSelection = e.tableSelection;

      let class_user_id = [];
      this.tableSelection.forEach((item) => {
        class_user_id.push(item.id);
      });
      this.formData.class_user_id = class_user_id.join(",");

      this.dialogVisible = true;
    },
    //确定按钮
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.roleType == 1 || this.roleType == 2) {
            this.formData.insurance_type_id = this.formData.type;
          }
          if (this.roleType == 1) {
            let teacher_ids = [];
            this.tableSelection.forEach((item) => {
              teacher_ids.push(item.teacher_id);
            });
            this.formData.teacher_ids = teacher_ids.join(",");
          }
          if (this.roleType == 2) {
            let user_ids = [];
            this.tableSelection.forEach((item) => {
              user_ids.push(item.expert_id);
            });
            this.formData.user_ids = user_ids.join(",");
          }
          this.postApiBuy(this.formData).then((res) => {
            if (res.error_code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
                duration: messageDuration,
              });
              this.update();
            }
          });
        }
      });
    },
    //关闭回调
    onClose() {},
    //关闭结束回调
    onClosed() {
      this.$refs["form"].resetFields();
      this.formData.cost = 0;
      this.formData.total = 0;
      this.formData.file_id = "";
      this.fileList = [];
    },
    //获取保险方案
    getInsureScheme() {
      getApiInsureScheme().then((res) => {
        this.insureScheme = res.data;
      });
    },
    //获取德诚上传配置
    getDcUploadConfig() {
      GetKey_Url().then((res) => {
        this.dcUploadConfig = res.data;
      });
    },
    //转账凭证上传成功回调
    uploadSuccess(data) {
      let etag = data.upload.CompleteMultipartUploadResult.ETag;
      //去掉字符串的双引号
      etag = etag.replace(/"/g, "");
      UPloadFileApi({ etag }).then((res) => {
        const data = res.data;
        const params = {
          id: data.id,
          name: data.savename,
          url: data.savepath,
        };
        this.fileList.push(params);
        this.setFileid(this.fileList);
      });
    },
    ///转账凭证删除文件
    uploadFileRemove(file, fileList) {
      this.fileList.forEach((item, index) => {
        if (item.id == file.id) {
          this.fileList.splice(index, 1);
        }
      });
      this.setFileid(this.fileList);
    },
    //保险方案更改回调
    insureSchemeChange(id) {
      this.insureScheme.forEach((item) => {
        if (item.id == id) {
          this.formData.cost = item.cast;
          this.formData.total = this.formData.cost * this.formData.buy_num;
        }
      });
    },
    //设置上传文件id
    setFileid(list) {
      let list_new = [];
      list.forEach((item) => {
        list_new.push(item.id);
      });
      this.formData.file_id = list_new.join(",");
    },
  },
  watch: {},
  created() {
    this.getDcUploadConfig();
    this.getInsureScheme();
  },
};
</script>

<style lang="less" scoped></style>
